import { render } from "./CuentasUsuarios.vue?vue&type=template&id=3994f6f0"
import script from "./CuentasUsuarios.vue?vue&type=script&lang=js"
export * from "./CuentasUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__